import SessionTimeoutWarning from './SessionTimeoutWarning';

export default SessionTimeoutWarning;
